import Store from './general'
import Session from './session'
import History from './history'
import Visitor from './visitor'
import Messages from './messages'
import Widget from './widget'
import Theme from './theme'
import Options from './options'
import Reactions from './reactions'

export default {
  ...Store,
  ...Session,
  ...History,
  ...Visitor,
  ...Messages,
  ...Widget,
  ...Theme,
  ...Options,
  ...Reactions
}
